// First Created - 29 Apr 2026
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userAccountMapsAdapter = createEntityAdapter({})

const initialState = userAccountMapsAdapter.getInitialState()

export const userAccountMapsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({

        getUserAccountMaps: builder.query({
            query: (params) => ({
                url: '/userAccountMaps/getUserAccountMaps',
                params,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loaded = responseData.map(item => {
                    item.id = item._id
                    return item
                })
                return userAccountMapsAdapter.setAll(initialState, loaded)
            },
            providesTags: (result) => {
                if (result?.ids) {
                    return [
                        { type: 'UserAccountMap', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'UserAccountMap', id }))
                    ]
                } else {
                    return [{ type: 'UserAccountMap', id: 'LIST' }]
                }
            },
        }),

        createNewUserAccountMap: builder.mutation({
            query: (data) => ({
                url: '/userAccountMaps/createNewUserAccountMap',
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: [
                { type: 'UserAccountMap', id: 'LIST' },
                { type: 'User', id: 'LIST' }
            ]
        }),

        updateUserAccountMap: builder.mutation({
            query: (data) => ({
                url: '/userAccountMaps/updateUserAccountMap',
                method: 'PATCH',
                body: { ...data }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserAccountMap', id: arg.userAccountMapId },
                { type: 'UserAccountMap', id: 'LIST' },
                { type: 'User', id: 'LIST' }
            ],
        }),

        deleteUserAccountMap: builder.mutation({
            query: ({ userAccountMapId }) => ({
                url: '/userAccountMaps/deleteUserAccountMap',
                method: 'DELETE',
                body: { userAccountMapId }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserAccountMap', id: arg.userAccountMapId },
                { type: 'UserAccountMap', id: 'LIST' },
                { type: 'User', id: 'LIST' }
            ]
        }),

    }),
})

export const {
    useGetUserAccountMapsQuery,
    useCreateNewUserAccountMapMutation,
    useUpdateUserAccountMapMutation,
    useDeleteUserAccountMapMutation,
} = userAccountMapsApiSlice

export const selectUserAccountMapResult =
    userAccountMapsApiSlice.endpoints.getUserAccountMaps.select()

const selectUserAccountMapsData = createSelector(
    selectUserAccountMapResult,
    result => result.data
)

export const {
    selectAll: selectAllUserAccountMaps,
    selectById: selectUserAccountMapById,
    selectIds: selectUserAccountMapIds,
} = userAccountMapsAdapter.getSelectors(
    state => selectUserAccountMapsData(state) ?? initialState
)